__turbopack_context__.v({
  "active": "_8nnR7q_active",
  "bar": "_8nnR7q_bar",
  "businessProductCards": "_8nnR7q_businessProductCards",
  "cardInSwiper": "_8nnR7q_cardInSwiper",
  "dot": "_8nnR7q_dot",
  "gridLayout": "_8nnR7q_gridLayout",
  "layoutWrapper": "_8nnR7q_layoutWrapper",
  "layouts": "_8nnR7q_layouts",
  "pagination": "_8nnR7q_pagination",
  "slide": "_8nnR7q_slide",
  "slideActive": "_8nnR7q_slideActive",
  "sliderLayout": "_8nnR7q_sliderLayout",
  "sliderOnMobile": "_8nnR7q_sliderOnMobile",
  "sliderOnTablet": "_8nnR7q_sliderOnTablet",
  "swiperRoot": "_8nnR7q_swiperRoot",
  "toLeft": "_8nnR7q_toLeft",
  "toRight": "_8nnR7q_toRight",
});
